// import React from 'react';
import { Navbar, Container, Nav, Button, NavDropdown } from 'react-bootstrap';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import ClientLogo from './ClientLogo';
import VersionInfo from './VersionInfo';
// import { useEffect } from 'react';
// import { useApi } from '../utils/useApi'; // auto-refreshing fetch wrapper

// type clientFlagsType = {
//   show_tasks: boolean;
//   show_decisions: boolean;
// };

const AppNavbar = () => {
  const { isAuthenticated, user, logout, clientFlags } = useAuth();
  // const [ clientFlags, setClientFlags ] = useState<clientFlagsType | null>(null);
  const navigate = useNavigate();
  // const { apiFetch } = useApi();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const handleLogin = () => {
    navigate('/login');
  };

  const handlePasswordChangeRequest = () => {
    navigate('/password-change');
  };

  // useEffect(() => {
  //   console.log('useEffect -> User:', user);
  //   console.log('clientFlags: ',clientFlags)
  // }, [isAuthenticated, user, clientFlags]);

  // const setClient = async (clientId: number) => {
  //   if (loading) return; // Prevent multiple submissions
  //   setLoading(true);
  //   setError('');
  //   try {
  //     const response = await dedupedRequest({ method: 'POST', url: '/admin/tempclient', data: { clientId } }, { useCache: false });
  //     // console.log('Client selection response:', response.data);
  //     // console.log('Updated user from backend:', response.data.user);
  //     auth.setUser(response.data.user);
  //   } catch (err: any) {
  //     const msg =
  //       err?.response?.data?.message ||
  //       err?.response?.data?.detail ||
  //       err?.message ||
  //       'Kundenwahl fehlgeschlagen';
  //     setError(msg);
  //   } finally {
  //     setLoading(false);
  //   }
  // }
  

  return (
    <Navbar bg="light" expand="lg">
      <Container>
        {isAuthenticated && user && (
          <ClientLogo
            key={user.client?.id}
            clientId={user.client?.id ?? 0} 
            showClientName={true} />
        )} iLCT 
        <Navbar.Toggle aria-controls="main-navbar" />
        <Navbar.Collapse id="main-navbar" className="justify-content-end">
          {isAuthenticated && user ? (
          <Nav className="ms-auto">
            <>
              <Nav.Link onClick={() => navigate('/dashboard')}>Dashboard</Nav.Link>
              <Nav.Link onClick={() => navigate('/vorschriften')}>Vorschriften</Nav.Link>
              {clientFlags?.show_decisions && (
                <Nav.Link onClick={() => navigate('/bescheide')}>Bescheidregister</Nav.Link>
              )}
              {/* <Nav.Link onClick={() => navigate('/massnahmen')}>Maßnahmen</Nav.Link> */}
              {/* <Nav.Link onClick={() => navigate('/dashboard')}>Dashboard</Nav.Link> */}
            </>
          {((user.role=="superadmin") || (user.role=="lawyer")) && (
            <>
              <Nav.Link>|</Nav.Link>
              <Nav.Link onClick={() => navigate('/admin/laws')}>Datenmanagement</Nav.Link>
              <Nav.Link onClick={() => navigate('/admin/decision-dashboard')}>Bescheidverwaltung</Nav.Link>
              {/* <Nav.Link onClick={() => navigate('/client')}>Prozesslandkarte</Nav.Link> */}
            </>
          )}
          {user.role=="justiz" && (
            <>
              <Nav.Link onClick={() => navigate('/standards')}>Standards</Nav.Link>
              <Nav.Link onClick={() => navigate('/medizinprodukteregister')}>Medizinprodukteregister</Nav.Link>
            </>
          )}
            <NavDropdown title={user.username} align="end">
              <NavDropdown.Item onClick={handlePasswordChangeRequest}>Passwort ändern</NavDropdown.Item>
              <NavDropdown.Item onClick={handleLogout}>Logout</NavDropdown.Item>
              <NavDropdown.Item><VersionInfo /></NavDropdown.Item>
              {/* <NavDropdown.Item>{user.client_id}</NavDropdown.Item>
              <NavDropdown.Item>{user.client_name}</NavDropdown.Item> */}
            </NavDropdown>
          </Nav>
          ) : (
          <Nav className="ms-auto">
            <Button variant="outline-primary" onClick={handleLogin}>
              Login
            </Button>
          </Nav>
            )}
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default AppNavbar;
